import { FORUM } from "./Theme/styles";

export const EVENTS = {
  "task_created": { name: "Utworzenie", kolor: "#4FB477" },
  "task_deleted": { name: "Usunięcie", kolor: "#E06C6C" },
  "status_changed": { name: "Zmiana statusu", kolor: "#6C99FF" },
  "deadline_passed": { name: "Minięty deadline", kolor: "#E0A45C" },
  item_done: { name: "Odhaczenie", kolor: FORUM.tekstPrzygaszony },
  "item_undone": { name: "Cofnięcie", kolor: FORUM.tekstPrzygaszony },
  "claimed": { name: "Wzięcie na siebie", kolor: "#4FB477" },
  "released": { name: "Oddanie zespołowi", kolor: FORUM.tekstPrzygaszony },
  "assignment_deadline_set": { name: "Termin części", kolor: FORUM.tekstPrzygaszony },
  "task_edited": { name: "Edycja", kolor: FORUM.tekstPrzygaszony },
  "item_edited": { name: "Edycja pozycji", kolor: FORUM.tekstPrzygaszony },
  "item_deleted": { name: "Usunięcie pozycji", kolor: "#E06C6C" },
  "assignment_added": { name: "Nowa część", kolor: FORUM.tekstPrzygaszony },
  "assignment_removed": { name: "Usunięcie części", kolor: "#E06C6C" },
  "team_changed": { name: "Zmiana kategorii", kolor: FORUM.tekstPrzygaszony },
  "assignee_changed": { name: "Zmiana osoby", kolor: FORUM.tekstPrzygaszony },
};

export const eventInfo = (key) =>
  EVENTS[key] || { name: key, kolor: FORUM.tekstPrzygaszony };
